import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * LLM Node - For LLM-based processing steps
 */
function LLMNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;

  return (
    <div className={`process-node llm-node ${selected ? 'selected' : ''}`}>
      {/* Input Handle */}
      <Handle
        type="target"
        position={Position.Left}
        className="node-handle input-handle"
      />

      {/* Node Content */}
      <div className="node-header">
        <span className="node-icon">🤖</span>
        <span className="node-type-badge llm">LLM</span>
      </div>
      
      <div className="node-body">
        <div className="node-name">{data.name || 'LLM Node'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="node-model">
          {data.model || 'gpt-4o'}
          {data.knowledgeLinkCount > 0 && (
            <span className="knowledge-link-badge" title="Knowledge graph links">
              🔗 {data.knowledgeLinkCount}
            </span>
          )}
        </div>
      </div>

      {/* Output Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="node-handle output-handle"
      />
    </div>
  );
}

export default memo(LLMNode);
